import React from 'react'
import { connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import Heading from 'uiKit/texts/Heading'
import { DescriptionDatasets } from './components/DescriptionDatasets'

const styles = () => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
  },
  container: {
    padding: '24px',
  },
  paragraph: {
    fontFamily: 'Lato',
    fontSize: 15,
    fontWeight: 500,
    color: 'var(--color-text-secondary)',
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: 100,
    width: '100%',
    '@media (min-width:1380px)': {
      width: 'calc(100% - 48px)',
    },
  },
})

type DescriptionsProps = {
  classes: Record<string, string>
  activeBot: any
  adminUser: any
}

const Descriptions: React.FC<DescriptionsProps> = ({ classes }) => {
  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <Heading>Descriptions</Heading>
        <p className={classes.paragraph} style={{ marginBottom: 26 }}>
          This tab helps to provide descriptions for each integrated chatbot dataset.
        </p>
      </div>

      <div className={`${classes.itemContainer} ${classes.container} containerForItems`}>
        <DescriptionDatasets />
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  activeBot: state.activeBot,
  adminUser: state.adminUser,
})

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(Descriptions))
